// export const baseurl = 'http://127.0.0.1:8000/'
export const baseurl = 'https://admin.orbitztrading.com/'